import React, { useState } from 'react';
import api from '../services/api';
import { ShieldCheck, Loader2 } from 'lucide-react';

const TelaLogin = ({ onLogin }) => {
  const [telefone, setTelefone] = useState('');
  const [pass, setPass] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCarregando(true);
    setErro('');
    
    try {
      // O backend agora retorna success, user (nome, telefone, perfil)
      const res = await api.post('/login', { telefone, senha: pass });
      
      if (res.data.success) {
        // 1. Salva o objeto completo do usuário no localStorage
        localStorage.setItem('usuario_ctc', JSON.stringify(res.data.user));
        
        // 2. Avisa o App.js que o login foi bem sucedido
        // Passamos 'true' para o estado de autenticado
        onLogin(true);
      } else {
        setErro("Credenciais inválidas.");
      }
    } catch (err) {
      // Verifica se o erro veio do servidor com uma mensagem específica
      const msgErro = err.response?.data?.message || "Erro de conexão com o servidor.";
      setErro(msgErro);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6 font-sans">
      <div className="bg-slate-900 p-8 md:p-12 rounded-[50px] border-2 border-slate-800 w-full max-w-md shadow-2xl relative overflow-hidden">
        
        {/* Cabeçalho do Login */}
        <div className="text-center mb-10">
          <div className="bg-emerald-500/10 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 border border-emerald-500/20 text-emerald-500 shadow-[0_0_20px_rgba(16,185,129,0.1)]">
            <ShieldCheck size={40} />
          </div>
          <h1 className="text-3xl font-black text-white tracking-tighter italic">CTC-IT</h1>
          <p className="text-slate-500 text-[10px] font-black tracking-widest mt-3 uppercase">
            Acesso Restrito ao Suporte
          </p>
        </div>

        {/* Formulário */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-1">
            <label className="text-[9px] font-black text-slate-500 uppercase ml-4 tracking-widest">Telefone de Acesso</label>
            <input 
              type="text" 
              placeholder="19XXXXXXXXX" 
              className="w-full bg-slate-950 border-2 border-slate-800 p-5 rounded-3xl outline-none focus:border-emerald-500 text-white font-bold transition-all placeholder:text-slate-800" 
              value={telefone} 
              onChange={(e) => setTelefone(e.target.value)} 
              required 
            />
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-slate-500 uppercase ml-4 tracking-widest">Senha Digital</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              className="w-full bg-slate-950 border-2 border-slate-800 p-5 rounded-3xl outline-none focus:border-emerald-500 text-white font-bold transition-all placeholder:text-slate-800" 
              value={pass} 
              onChange={(e) => setPass(e.target.value)} 
              required 
            />
          </div>

          {erro && (
            <div className="bg-red-500/10 border border-red-500/20 p-4 rounded-2xl animate-in fade-in zoom-in duration-300">
              <p className="text-red-500 text-[9px] font-black text-center uppercase tracking-wider">
                {erro}
              </p>
            </div>
          )}

          <button 
            disabled={carregando} 
            className={`w-full py-6 rounded-[30px] font-black text-white text-xs tracking-widest transition-all shadow-lg flex items-center justify-center gap-3 active:scale-95 ${
              carregando 
                ? 'bg-slate-800 cursor-not-allowed' 
                : 'bg-emerald-600 hover:bg-emerald-500 shadow-emerald-500/20'
            }`}
          >
            {carregando ? (
              <>
                <Loader2 size={18} className="animate-spin" />
                VERIFICANDO...
              </>
            ) : "ENTRAR NO SISTEMA"}
          </button>
        </form>

        {/* Efeito Visual de Fundo */}
        <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-emerald-500/5 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
};

export default TelaLogin;